import { scopedRaf } from './chunk-Z6A4GYXE.js';
import { useMedia } from './chunk-ZIBTY3GT.js';
import { effect, peek } from 'maverick.js';
import { defineElement, Component } from 'maverick.js/element';
import { listenEvent, isPointerEvent, isMouseEvent, isTouchEvent } from 'maverick.js/std';

var lastGesture = /* @__PURE__ */ new WeakMap();
var Gesture = class extends Component {
  constructor() {
    super(...arguments);
    this.R = null;
    this.ae = 0;
  }
  onAttach() {
    const { event, action } = this.$props;
    this.setAttributes({
      event,
      action
    });
  }
  onConnect() {
    this.a = useMedia();
    scopedRaf(() => {
      this.R = this.a.player.querySelector("media-outlet");
      effect(this.kh.bind(this));
    });
  }
  onDisconnect() {
    if (this.R && lastGesture.get(this.R) === this) {
      lastGesture.delete(this.R);
    }
  }
  kh() {
    let eventType = this.$props.event();
    if (!this.R || !eventType)
      return;
    if (/^dbl/.test(eventType)) {
      eventType = eventType.split(/^dbl/)[1];
    }
    listenEvent(this.R, eventType, this.lh.bind(this));
  }
  lh(event) {
    if (!this.mh(event))
      return;
    if (!peek(this.$props.event)?.startsWith("dbl")) {
      lastGesture.set(this.R, this);
      setTimeout(() => {
        if (lastGesture.get(this.R) === this) {
          this.be(event);
        }
      }, 220);
    } else if (Date.now() - this.ae <= 200) {
      lastGesture.set(this.R, this);
      queueMicrotask(() => {
        this.be(event);
      });
    }
    this.ae = Date.now();
  }
  be(event) {
    this.el.setAttribute("data-triggered", "");
    requestAnimationFrame(() => {
      if (this.nh()) {
        this.oh(peek(this.$props.action), event);
      }
      requestAnimationFrame(() => {
        this.el.removeAttribute("data-triggered");
      });
    });
  }
  /** Validate event occurred in gesture bounds. */
  mh(event) {
    if (isPointerEvent(event) || isMouseEvent(event) || isTouchEvent(event)) {
      const touch = isTouchEvent(event) ? event.touches[0] : void 0;
      const clientX = touch?.clientX ?? event.clientX;
      const clientY = touch?.clientY ?? event.clientY;
      const rect = this.el.getBoundingClientRect();
      const inBounds = clientY >= rect.top && clientY <= rect.bottom && clientX >= rect.left && clientX <= rect.right;
      return event.type.includes("leave") ? !inBounds : inBounds;
    }
    return true;
  }
  /** Validate gesture has the highest z-index in this triggered group. */
  nh() {
    const gestures = this.R.querySelectorAll(
      "media-gesture[data-triggered]"
    );
    return Array.from(gestures).sort(
      (a, b) => +getComputedStyle(b).zIndex - +getComputedStyle(a).zIndex
    )[0]?.component === this;
  }
  oh(action, trigger) {
    if (!action)
      return;
    const [method, value] = action.replace(/:([a-z])/, (_, $1) => $1.toUpperCase()).split(":");
    if (action.includes(":fullscreen")) {
      this.a.remote.toggleFullscreen("prefer-media", trigger);
    } else if (action.includes("seek:")) {
      this.a.remote.seek(peek(this.a.$store.currentTime) + (+value || 0), trigger);
    } else {
      this.a.remote[method](trigger);
    }
  }
};
Gesture.el = defineElement({
  tagName: "media-gesture",
  props: {
    event: void 0,
    action: void 0
  }
});

export { Gesture };
